import { render, staticRenderFns } from "./AtomListElementActionsPrimary.vue?vue&type=template&id=6871e749&"
import script from "./AtomListElementActionsPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomListElementActionsPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports